import { computed } from '@angular/core';
import { FieldTree } from '@angular/forms/signals';

import { BaasEditValidation } from '../baas-edit.types';
import { BaasEditFormDriver } from './baas-edit-form.driver';

/**
 * Driver for Signal Forms (FieldTree).
 */
export class SignalFormDriver implements BaasEditFormDriver {
    #form: FieldTree<any, number | string>;

    constructor(form: FieldTree<any, number | string>) {
        this.#form = form;
    }

    readonly pristine = computed(() => !this.#form().dirty());

    readonly valid = computed(() => this.#form().valid());

    readonly disabled = computed(() => this.#form().disabled());

    readonly readonly = computed(() => this.#form().readonly());

    readonly submitting = computed(() => this.#form().submitting());

    readonly pending = computed(() => this.#form().pending());

    readonly validations = computed(() => {
        const seen = new Set<string>();
        return this.#form()
            .errorSummary()
            .map((v) => v.message)
            .filter((message) => {
                if (seen.has(message)) {
                    return false;
                }

                seen.add(message);
                return true;
            })
            .map((message) => ({ message }) as BaasEditValidation);
    });

    markAsPristine(): void {
        this.#form().reset();
    }

    focusFirstInvalidField(): void {
        this.#form().errorSummary()[0]?.fieldTree().focusBoundControl();
    }
}
